export default __webpack_public_path__ + "static/media/mobile.7dfcc063.svg";